
let styles = {
  container: {
    padding: '1%',
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    backgroundColor: '#FFFFFF'
  },

  table: {
    backgroundColor: '#FFFFFF',
    padding: '1%',
    width: '101%'
  },

  items: {
    padding: '1%',
  },

  item_header: {
    fontSize: '120%',
    fontWeight: 600,
    paddingLeft: '10%',
  },

  item_body: {
    padding: '4px ',
  },
  select_body:{
    padding: '4px ',
    marginRight: '10px'
  },

  main_header: {
    marginBottom: '3%',
    backgroundColor: '#95daee',
  },

  button_submit: {
    padding: '1%',
    justifyContent: 'center',
    display: 'flex',
    paddingTop: '6%',
  },

  input: {
    width: '30%',
    textAlign: 'center',
  },

  success: {
    textAlign: 'center',
    fontSize: '120%',
    fontWeight: 800,
  },
  resp_table_header:{
    display: 'table-header-group',
    backgroundColor: '#e7f3fc',
  },
  resp_table_caption:{
    display: 'table-caption'
  },
  resp_table_cells:{
    display: 'table-cell',
    textAlign: 'center',
    margin: '1px',
    fontSize: '16px',
    fontWeight: 'bold',
    width: '117px',
  },
  resp_table_body:{
    display: 'table-row-group',
  },
  resp_table_row:{
    display: 'table-row',
    // border: '1px solid black',
    margin: '1px',
    boxShadow: '1px 0px 3px 2px #f2f2f2'
  },
  resp_table_cell:{
    display: 'table-cell',
    padding: '15px',
    fontWeight: 'bold',
    width: '120px',
  },
  resp_table_cell_days:{
    display: 'table-cell',
    padding: '15px',
    fontWeight: 'bold',
    width: '120px',
    flexDirection: 'column',
    // boxShadow: '1px 1px 3px 2px #666666'
  },
  resp_table_cell_none:{
    display: 'table-cell',
    width: '120px',
    textAlign: 'left',
    fontWeight: 'bold',
    padding: '15px',
  },
  resp_table_cell_time:{
    display: 'table-cell',
    width: '120px',
    textAlign: 'center',
    fontWeight: 'bold',
    padding: '15px',
  },
  titles:{
    textAlign: 'center',
    fontWeight: 'bold', 
    color: '#ac3a35',
    display: 'flex',
    textDecoration: 'underline',
  },
  content:{
    textAlign: 'left',
    fontWeight: 'bold', 
    fontSize: '14px'
  },
  row_content:{
    flexDirection: 'row', 
    justifyContent: 'space-between', 
    flexWrap: 'wrap', 
    border: '1px solid #C4C1C1', 
    textAlign: 'left',
    padding: '11%',
  },
}
export default styles



// WEBPACK FOOTER //
// ./src/app/views/batchhealth/style.js